import { Injectable } from '@angular/core';
import { BundleProductSchema } from '../models/bundle-product.schema';
import { ToTypeOrm } from '../models/_to-type-orm.schema';
import { ApiAuthService } from './api-auth.service';

@Injectable({
  providedIn: 'root'
})
export class BundleProductsService extends ApiAuthService {

  private readonly url = `${this.baseUrl}/bundle-products`;

  async getAllBundleProducts(page?: number, limit?: number, order?: {}, filter: any = {}, province?: string): Promise<{
    bundleProducts: BundleProductSchema[],
    count: number
  }> {
    return this.getAll(page, limit, order, filter, province);
  }
  
  async getAll(page?: number, limit?: number, order?: {}, filter?: { [key: string]: ToTypeOrm }, province?: string): Promise<{
    bundleProducts: BundleProductSchema[],
    count: number
  }>{
    let params: any = {
      page,
      limit,
      order: JSON.stringify(order),
      filter: JSON.stringify(filter),
    };
    if (page) params['page'] = page;
    if (limit) params['limit'] = limit;
    if (order) params['order'] = JSON.stringify(order);
    if (filter) params['filter'] = JSON.stringify(filter);
    if (province) {
      params.province = province;
    }
    return this.request(() => this.http.get<{ bundleProducts: BundleProductSchema[], count: number }>(`${this.url}`, { params: params }).toPromise() );
  }

  async getOne(id: string|number): Promise<BundleProductSchema> {
    return this.request(() => this.http.get<BundleProductSchema>(`${this.url}/${id}`).toPromise());
  }

  async create(customerParams: BundleProductSchema): Promise<BundleProductSchema> {
    let body = customerParams;
    return this.request(() => this.http.post<BundleProductSchema>(`${this.url}`, body).toPromise());
  }

  async update(id: number, customerParams: BundleProductSchema): Promise<BundleProductSchema> {
    let body = customerParams;
    return this.request(() => this.http.put<BundleProductSchema>(`${this.url}/${id}`, body).toPromise());
  }

  async delete(id: number): Promise<{ id: number, success: boolean }> {
    return this.request(() => this.http.delete<{ id: number, success: boolean }>(`${this.url}/${id}`).toPromise());
  }
}
